import { TabsReducer } from '../../../common/tabs/tabs.reducer';

export const docTabs = {
    'app.policies.documents.add': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.documents.add.details',
                title: 'Document Details',
                visible: true,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    },
    'app.policies.documents.manage': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.documents.manage.listing',
                title: 'Documents',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.documents.manage.details',
                title: 'Document Details',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            },
            {
                state: 'app.policies.documents.manage.history.listing',
                title: 'Document History',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.documents.manage.history.details',
                title: 'Document History View',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.documents.accreditation.manage.listing',
                title: 'List Accreditation Schemes',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.documents.accreditation.add.details',
                title: 'Action Accreditation Schemes ',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            },
            {
                state: 'app.policies.documents.manage.eventActions.listing',
                title: 'List Event Actions',
                visible: false,
                disabled: false,
                loading: false,
            },
        ]
    },
    'app.policies.documents.approval': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.documents.approval.listing',
                title: 'Documents',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.documents.approval.details',
                title: 'Document Details',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    }
};
